var bighouse = bighouse || {};

bighouse.searcharchive = (function () {

    var filtersOpen = false; 
    var currentFilters = {};
    var newFilters = {};
    var pageSize = 9;
    var lastFocus;



    function init() {

        if( $('.js-filterToggle').length === 0)
            return;

        pageSize = $('#hdnPageSize').val();
        currentFilters = setCurrentFilters();
        updateCount();
        bindFilters();
    }




    function setCurrentFilters(){
        //loop through current filters and set
        var tempArray={};

        $('.FilterOverlay-group').each(function(e){
            var currentName = $(this).find('input[type=checkbox]').first().attr('name');
            tempArray[currentName] = [];
        });


        $('.js-filters input:checked').each(function(e){
            if( !$(this).hasClass('js-filterAll') ){
                tempArray[  $(this).attr('name') ].push( $(this).val() );
            }
        });

        return tempArray;
    }


    function bindFilters(){

        $('.js-filterToggle').on('click', function (e) {
            if(  $('.FilterOverlay').attr('aria-hidden') === 'true' ){
                open();
            } else {
                revertFilters();
                close(e);
            }
            e.preventDefault();
        });

        checkAnyLogic();

        $('.js-filterCancel').on('click', function (e) {
            revertFilters();
            close(e);
            e.preventDefault();
        });

        $('.js-filterReset').on('click', function(e){
            //click all any checkboxes
            //apply ajax
            $('.js-filterAll').trigger('click');
            $('.js-filters')[0].scrollTop = 0;
            applySearchAjax(e, 1);
            e.preventDefault();
        });

        $('.js-filterApply').on('click', function(e){
            applySearchAjax(e, 1);
            e.preventDefault();
        });

        $('.js-searchLoadMore').on('click', function (e) {
            //get the current page number and add 1.
            var pageNumber = parseInt($('#hdnPageNumber').val());
            $(this).addClass('loading');

            $('html, body').animate({
                scrollTop: ($('.js-searchLoadMore').offset().top - $('.js-stickyNavHeader').height() - 20)
            }, 1000);

            $(this).blur();

            applySearchAjax(e, (pageNumber + 1));
            e.preventDefault();
        });

    }


    function checkAnyLogic(){

        $('.js-filterAll').each(function(e){
            var theName = $(this).attr('name');

            $('input[name='+theName+']').on('change', function(e){
                var isAny = $(this).hasClass('js-filterAll');

                //if 'Any'
                    // uncheck the rest
                // else
                    //count all the inputs not including the anyFilters
                    //if count === 0 then set anyFilters as checked
                    //else uncheck anyFilters

                if(isAny){
                    $('input[name='+theName+']').prop('checked', false);
                    $('input[name='+theName+'].js-filterAll').prop('checked', true);
                } else {
                    var count = $('input[name='+theName+']:not(.js-filterAll):checked').length;
                    if(count===0){
                        $('input[name='+theName+'].js-filterAll').prop('checked', true);
                    } else {
                        $('input[name='+theName+'].js-filterAll').prop('checked', false);
                    }
                }
            });
        });
    }



    function applySearchAjax(e, pageNumber) {

        //remove error messages
        $('.js-searchError').addClass('u-hide');

        //get new filters
        newFilters = setCurrentFilters();
        var apidomain = window.location.protocol + "//" + window.location.host;

        console.log(apidomain);


        if( (newFilters !== currentFilters) && apidomain.indexOf('localhost') === -1 ){
        
            //TODO: set animation running

            var filterData = createFilterData(newFilters, pageNumber);

            $.ajax({
                url: apidomain + '/umbraco/api/search/GetSearchResults',
                dataType: 'json',
                type: 'post',
                data: filterData,
                error: function () {
                    //show an error message
                    $('.js-searchError').removeClass('u-hide');
                    stopGenericTasks();
                },
                success: function (data) {
                    stopGenericTasks();
                    ajaxSuccess(data, pageNumber, newFilters);
                    close(e);
                }
            });

        } else {
            close(e);
        }
    }


    function stopGenericTasks() {
        //TODO: remove animation


        //remove button animation
        $('.js-searchLoadMore').removeClass('loading');
    }


    function ajaxSuccess(data, pageNumber, newFilters) {

        //update page number
        $('#hdnPageNumber').val(pageNumber);

        //update currentFilters var
        currentFilters = newFilters;

        //update count on filter button
        updateCount();



        var totalCount = (data !== null) ? data.totalCount : 0;

        //show/hide the load more button
        if (totalCount > (pageNumber * pageSize)) {
            $('.js-searchLoadMore').removeClass('u-hide');
        } else {
            $('.js-searchLoadMore').addClass('u-hide');
        }



        //update results count
        $('.js-searchCount').html(totalCount);

        if (data === null) {
            //no results
            $('.js-searchNoResults').removeClass('u-hide');
            $('.js-searchList').html('');
        } else {
            $('.js-searchNoResults').addClass('u-hide');
            //create the items and append / replace
            generateProducts(pageNumber, data.products);
        }

        //update query string
        if (history.pushState) {
            var queryString = createQueryString();
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + queryString;
            window.history.pushState({ path: newurl }, '', newurl);
        }
    }


    function open() {
        // store the last place the user opened the lightbox from
        lastFocus = document.activeElement;
        $('body, html').addClass('noscroll u-filtersOpen');
        var filterMenu = $('.FilterOverlay');
        filterMenu.attr('aria-hidden', 'false');
        filtersOpen = true;
        filterMenu.find('.FilterOverlay-inner').attr('tabindex', '0').focus();

        $(filterMenu).scrollTop(0);
    }


    function close(e) {

        if (filtersOpen && (!e.keyCode || e.keyCode === 27)) {
            $('.FilterOverlay').attr('aria-hidden', 'true');
            $('.FilterOverlay-inner').attr('tabindex', '-1');
            filtersOpen = false;
            $('body, html').removeClass('noscroll u-filtersOpen');
            lastFocus.focus();
            $('.js-filterToggle').blur();
        }
    }


    function generateProducts(pageNumber, results) {  
        var markup = '';

        //loop through each ticket
        $.each(results, function () {
            markup += generateProduct(this);
        });

        //if pageNumber is 1 then overwrite, if pageNumber is greater then append to end
        if (pageNumber === 1) {
            $('.js-searchList').html(markup);
        } else {
            $('.js-searchList').append(markup);
        }
    }


    function generateProduct(currentProduct) {

        var categories = '';

        $.each(currentProduct.categories, function (key, value) {
            categories += '<a href="' + value.url + '">' + value.name + '</a>';
        });
  

        var data = {
            "url": currentProduct.url,
            "imageUrl": currentProduct.imageUrl,
            "imageAlt": currentProduct.imageAlt,
            "categories": categories,
            "title": currentProduct.title,
            "summary": currentProduct.summary,
            "prodInfo1": currentProduct.prodInfo1,
            "prodInfo2": currentProduct.prodInfo2
        };

        var productMarkup = $('#templateProduct').html();
        return util.template(productMarkup, data);
    }


    function revertFilters(){
        newFilters = setCurrentFilters();

        if(JSON.stringify(newFilters) !== JSON.stringify(currentFilters) ){
            //go through the inputs and reset to current.

            $.each(currentFilters, function (key, value) {

                //reset all
                $('input[name=' + key + '].js-filterAll').trigger('click');
                var name = key;

                if (value.length > 0) {
                    //loop through values and check the correct ones
                    $.each(value, function (key, value) {
                        $('input[name=' + name + '][value=' + value + ']').trigger('click');
                    });
                }
            });

        } else {
            //no need to do anything
        }

        newFilters = currentFilters;
    }



    function updateCount(){
        var newCount = countTags(currentFilters);
        $('.js-filterCount').html(newCount);

        if(newCount === 0){
            $('.Filters').addClass('Filters--noFilters');
        } else {
            $('.Filters').removeClass('Filters--noFilters');
        }
    }


    function countTags(){
        var count = $('.FilterOverlay-group input:not(.js-filterAll):checked').length;
        return count;
    }


    function createQueryString(){
        var qStr = '';
        var pageNumber = $('#hdnPageNumber').val();

        $.each(currentFilters, function(key, value){
            if(value.length > 0){
                if (qStr.length > 0) qStr += '&'; //if there's already vars, need an &
                qStr += key + '=' + value.join('|');
            }
        });
        return '?' + qStr + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber;
    }


    function createFilterData(newFilters, pageNumber) {
        var filterData = {
            "pageNumber": pageNumber,
            "pageSize": pageSize
        };

        $.each(newFilters, function (key, value) {
            if (value.length > 0) {
                filterData[key] = value.join('|');
            }
        });

        return filterData;
    }


    return {
        init: init
    };
})();